var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProjectLightEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 110,
    viewBox: "0 0 200 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.617 14C196.247 14 200 17.7533 200 22.3832C200 27.0132 196.247 30.7665 191.617 30.7665H143.713C148.342 30.7665 152.096 34.5198 152.096 39.1497C152.096 43.7796 148.342 47.5329 143.713 47.5329H170.06C174.69 47.5329 178.443 51.2862 178.443 55.9162C178.443 60.5461 174.69 64.2994 170.06 64.2994H157.876C152.038 64.2994 147.305 68.0527 147.305 72.6826C147.305 75.7693 149.701 78.5637 154.491 81.0659C159.121 81.0659 162.874 84.8192 162.874 89.4491C162.874 94.079 159.121 97.8323 154.491 97.8323H55.0898C50.4599 97.8323 46.7066 94.079 46.7066 89.4491C46.7066 84.8192 50.4599 81.0659 55.0898 81.0659H8.38323C3.7533 81.0659 0 77.3126 0 72.6826C0 68.0527 3.7533 64.2994 8.38323 64.2994H56.2874C60.9174 64.2994 64.6707 60.5461 64.6707 55.9162C64.6707 51.2862 60.9174 47.5329 56.2874 47.5329H26.3473C21.7174 47.5329 17.9641 43.7796 17.9641 39.1497C17.9641 34.5198 21.7174 30.7665 26.3473 30.7665H74.2515C69.6216 30.7665 65.8683 27.0132 65.8683 22.3832C65.8683 17.7533 69.6216 14 74.2515 14H191.617ZM191.617 47.5329C196.247 47.5329 200 51.2862 200 55.9162C200 60.5461 196.247 64.2994 191.617 64.2994C186.987 64.2994 183.234 60.5461 183.234 55.9162C183.234 51.2862 186.987 47.5329 191.617 47.5329Z",
    fill: "#D6DCE8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0271 22.1925H149.386C152.819 22.1925 155.423 24.7971 155.423 28.2303V82.3341C155.423 85.7674 152.819 88.3719 149.386 88.3719H64.0271C60.5938 88.3719 57.9893 85.7674 57.9893 82.3341V28.2303C57.9893 24.7971 60.8306 22.1925 64.0271 22.1925Z",
    fill: "url(#paint0_linear_12867_58517)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M139.06 28.2261L139.785 86.6369C139.785 88.6323 138.153 90.1742 136.157 90.1742H79.1978C77.2024 90.1742 75.5698 88.5416 75.5698 86.6369V11.5373C75.5698 9.5419 77.2024 8 79.1978 8H120.466L139.06 28.2261Z",
    fill: "url(#paint1_linear_12867_58517)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M112.485 20.2447H85.184C84.5491 20.2447 84.0049 19.7005 84.0049 19.0656C84.0049 18.4307 84.5491 17.8865 85.184 17.8865H112.485C113.12 17.8865 113.664 18.4307 113.664 19.0656C113.664 19.7005 113.12 20.2447 112.485 20.2447Z",
    fill: "#D5DDEA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7052 26.7751H85.184C84.5491 26.7751 84.0049 26.2309 84.0049 25.596C84.0049 24.9611 84.5491 24.4169 85.184 24.4169H95.6145C96.2494 24.4169 96.7936 24.9611 96.7936 25.596C96.7936 26.2309 96.2494 26.7751 95.7052 26.7751Z",
    fill: "#D5DDEA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M120.466 8.00006V24.1447C120.466 26.4122 122.462 28.2262 124.729 28.2262H139.06",
    fill: "#D5DDEA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M131.46 40.5674H121.562H119.109H85.5249C85.1019 40.5674 84.679 40.9913 84.679 41.5847C84.679 42.0933 85.0173 42.602 85.5249 42.602H119.109H121.562H131.375C131.968 42.602 132.306 42.1781 132.306 41.5847C132.306 41.076 131.968 40.5674 131.46 40.5674Z",
    fill: "#D5DDEA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M162.053 33.7947H126.063C122.511 33.7947 119.196 34.9785 116.473 37.2279L107.002 44.9232C104.398 47.0542 100.964 48.3565 97.4128 48.3565H56.687C52.5434 48.3565 49.2285 51.7898 49.2285 55.815C49.2285 56.1702 49.2285 56.5253 49.3469 56.8805L56.8054 96.7776C57.3974 100.566 60.5939 103.289 64.2639 103.289H151.398C155.187 103.289 158.265 100.684 158.857 96.896L169.393 42.3187C170.104 38.175 167.381 34.505 163.237 33.6763C162.882 33.7947 162.408 33.7947 162.053 33.7947Z",
    fill: "url(#paint2_linear_12867_58517)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12867_58517",
    x1: 106.714,
    y1: 24.4915,
    x2: 106.714,
    y2: 61.6373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12867_58517",
    x1: 107.657,
    y1: 6.09923,
    x2: 107.657,
    y2: 91.0601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12867_58517",
    x1: 109.328,
    y1: 32.0661,
    x2: 109.328,
    y2: 104.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectLightEmpty);
export default __webpack_public_path__ + "static/media/projectLightEmpty.d560077108124d79fcd8b070378c7738.svg";
export { ForwardRef as ReactComponent };